import * as z from "zod/v4";

export const getIntercomDailyMetrics = {
  name: "getIntercomDailyMetrics" as const,

  input: z.object({
    dateRange: z
      .object({ start: z.date().nullable(), end: z.date().nullable() })
      .optional(),
    excludeProducts: z.array(z.string()).optional(),
    sourceType: z.enum(["all", "email", "web", "slack"]).optional(),
  }),

  output: z.object({
    totalCount: z.number(),
    emailAttempted: z.number(),
    emailResolved: z.number(),
    emailEscalated: z.number(),
    slackAttempted: z.number(),
    slackResolved: z.number(),
    slackEscalated: z.number(),
    daily: z.array(
      z.object({
        date: z.string(),
        totalCount: z.number(),
        emailAttempted: z.number(),
        emailResolved: z.number(),
        emailEscalated: z.number(),
        slackAttempted: z.number(),
        slackResolved: z.number(),
        slackEscalated: z.number(),
      }),
    ),
    attemptedConversationIds: z.array(z.string()),
    conversationTags: z.record(
      z.string(),
      z.object({
        attempted: z.boolean(),
        resolved: z.boolean(),
        escalated: z.boolean(),
      }),
    ),
  }),
};
